import { render } from "./PresentersInstructions.vue?vue&type=template&id=15cf4fac"
import script from "./PresentersInstructions.vue?vue&type=script&lang=js"
export * from "./PresentersInstructions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__